import api from './api';

// Helper para extrair dados da resposta
// NOTA: ReferenceHandler.Preserve foi removido da API
// Agora a API retorna arrays e objetos normais sem $values
const extractData = (data) => {
  // Se for um objeto com $values (legacy), extrair o array
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  // Retornar como está (array ou objeto)
  return data;
};

const personsService = {
  // Listar todas as pessoas
  getAll: async (params = {}) => {
    const response = await api.get('/persons', { params });
    return extractData(response.data);
  },

  // Buscar pessoa por ID
  getById: async (id) => {
    const response = await api.get(`/persons/${id}`);
    return extractData(response.data);
  },

  // Criar nova pessoa
  create: async (data) => {
    const response = await api.post('/persons', data);
    return extractData(response.data);
  },

  // Atualizar pessoa
  update: async (id, data) => {
    const response = await api.put(`/persons/${id}`, data);
    return extractData(response.data);
  },

  // Deletar pessoa
  delete: async (id) => {
    const response = await api.delete(`/persons/${id}`);
    return extractData(response.data);
  },

  // Alternar status ativo/inativo
  toggleActive: async (id) => {
    const response = await api.patch(`/persons/${id}/toggle-active`);
    return extractData(response.data);
  }
};

export default personsService;
